import { format } from 'date-fns';
import { DiagnosticSkillHistoryTableItem } from '../components/AssessmentHistory/models';
import { SkillAssessmentTableItem } from '../components/AssessmentHistory/SkillAssessmentTable';
import { createAndExportCSV } from './createAndExportGenericCSV';
import { AssessmentHistoryType } from '../models/CsvExport';

export const parseDataFromDiagnostic = (data: DiagnosticSkillHistoryTableItem[]) => {
  return data.map(item => [item.skill?.name || '', item.skill?.code || '', item.placedOut.length.toString()]);
};

export const parseDataFromSkill = (data: SkillAssessmentTableItem[]) => {
  return data.map(item => [
    item.studentName || '',
    item.skillName || '',
    item.skill?.code || '',
    String(item.attempted) || '0',
    item.completedOn ? format(new Date(item.completedOn), 'Pp') : '',
    item.score != null ? `${item.score}0%` : '',
  ]);
};

export const exportToCsvAssessmentHistoryTable = async (
  values: DiagnosticSkillHistoryTableItem[] | SkillAssessmentTableItem[],
  source: AssessmentHistoryType,
) => {
  const headers =
    source === AssessmentHistoryType.DIAGNOSTIC_ASSESSMENTS
      ? ['Skill Name', 'Skill Code', 'Placed Out']
      : ['Name', 'Skill Name', 'Skill Number', 'Attempt', 'Date Completed', 'Result'];

  const valuesCsv =
    source === AssessmentHistoryType.DIAGNOSTIC_ASSESSMENTS
      ? parseDataFromDiagnostic(values as DiagnosticSkillHistoryTableItem[])
      : parseDataFromSkill(values as SkillAssessmentTableItem[]);

  createAndExportCSV(headers, valuesCsv);
};
